module.exports = __webpack_public_path__ + "b69de69a4ff8ca0abe96ec0b0c180c5b.ttf";